// extracted by mini-css-extract-plugin
export default {"Container":"ControlBoxMg_Container__uDTsL","box":"ControlBoxMg_box__iaZkh"};